import type { RouteLocationNormalized } from 'vue-router';

export type ScrollPosition = {
  left: number;
  top: number;
  anchorId?: string;
  anchorOffset?: number;
  scrollHeight?: number;
};

const STORAGE_KEY = 'topauto:scroll-positions';

const normalizeKey = (route: RouteLocationNormalized) => route.fullPath.split('#')[0];

const readStorage = (): Record<string, ScrollPosition> => {
  if (!process.client) return {};
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return {};
  try {
    return JSON.parse(raw) as Record<string, ScrollPosition>;
  } catch {
    return {};
  }
};

const writeStorage = (positions: Record<string, ScrollPosition>) => {
  if (!process.client) return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(positions));
};

export const getRouteScrollKey = (route: RouteLocationNormalized) => normalizeKey(route);

export const shouldKeepScroll = (route: RouteLocationNormalized) =>
  Boolean(route.meta?.keepScroll);

export const readScrollPosition = (route: RouteLocationNormalized): ScrollPosition | null => {
  if (!process.client) return null;
  const positions = readStorage();
  return positions[normalizeKey(route)] ?? null;
};

export const writeScrollPosition = (route: RouteLocationNormalized, position: ScrollPosition) => {
  if (!process.client) return;
  const positions = readStorage();
  positions[normalizeKey(route)] = position;
  writeStorage(positions);
};
